/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { BsSortDown, BsSortUp } from 'react-icons/bs';
import { SortDataPayload } from '../../models/sort';

export const HederCell = ({
  text,
  sortKey,
  sortBy,
  sortDirection,
  setSort,
  className,
}: {
  sortBy?: string;
  text: string;
  sortKey?: string;
  sortDirection?: string;
  setSort?: (data: SortDataPayload) => void;
  className?: string;
}) => {
  const isDesc = sortKey !== sortBy || (sortKey === sortBy && sortDirection === 'asc');

  const isAsc = sortKey === sortBy && sortDirection === 'desc';

  const direction = isDesc ? 'desc' : isAsc ? 'asc' : 'desc';

  return (
    <span
      className={`heder-cell d-block ${className}`}
      onClick={() =>
        setSort &&
        setSort({
          key: sortKey || '',
          direction,
        })
      }
    >
      <div className="d-flex align-items-center">
        {text}
        <span
          className={`display-inline-block direction-toggle ps-1 ${
            sortKey === sortBy ? 'active' : ''
          }`}
        >
          {isDesc && <BsSortUp size={16} />}

          {isAsc && <BsSortDown size={16} />}
        </span>
      </div>
    </span>
  );
};
